import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Modal, Button as BButton, Spinner, ListGroup } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
    faUserPlus, 
    faDownload,
    faUserTag,
    faBars,
    faCog
} from '@fortawesome/free-solid-svg-icons';
import PerfectScrollbar from "react-perfect-scrollbar";
import swal from 'sweetalert';
import { createRolection, updateRoleAction, deleteParamAction, getRolesAction, resetSaveDoneAction, startLoader } from '../../../store/actions/UserAction';
import Select from 'react-select';
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Tag } from 'primereact/tag';
import { Calendar } from 'primereact/calendar';
import { DataTableBase } from '../DataTables/DataTableBase';
import { currentUser } from "../../../store/selectors/CurrentUserSelector";
import { useTranslation } from "react-i18next";

const Role = (props) => {
    const { t } = useTranslation();
    let errorsObj = { name: '', code: '' };
    
    // Form states
    const [nameFr, setNameFr] = useState('');
    const [nameEn, setNameEn] = useState('');
    const [code, setCode] = useState('');
    const [menus, setMenus] = useState([]);
    const [errors, setErrors] = useState(errorsObj);
    const [id, setId] = useState('');
    const [updateMode, setUpdateMode] = useState(false);
    
    // Modal states
    const [addCard, setAddCard] = useState(false);

    // Filter states
    const [filters, setFilters] = useState(null);
    const [globalFilterValue, setGlobalFilterValue] = useState('');

    const initFilters = () => {
        setFilters({
            global: { value: null, matchMode: FilterMatchMode.CONTAINS },
            roleCode: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            roleNameFr: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            'menus.menuNameFr': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            createdAt: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }] },
        });
        setGlobalFilterValue("");
    };

    const renderHeader = () => {
        return (
            <div className="d-flex justify-content-between align-items-center">
                <Button 
                    type="button" 
                    icon="pi pi-filter-slash"  
                    label={t('common.reinit')} 
                    outlined 
                    onClick={clearFilter}
                    className="me-2"
                    size="small"
                />
                <div className="p-input-icon-left">
                    <i className="pi pi-search" />
                    <InputText 
                        value={globalFilterValue} 
                        onChange={(e) => onGlobalFilterChange(e)} 
                        placeholder={t('common.search')}
                        size="small"
                    />
                </div>
            </div>
        );
    };

    const clearFilter = () => {
        initFilters();
    };

    const onGlobalFilterChange = (e) => {
        const value = e.target.value;
        let _filters = { ...filters };
        _filters['global'].value = value;
        setFilters(_filters);
        setGlobalFilterValue(value);
    };

    const setColumns = () => {
        return [
            {name: 'roleCode', headerName: "Code", filterPlaceholder: 'Filtrer par code', style: { minWidth: '12rem' }, filter: true, bodyTemplate: null},
            {name: 'roleNameFr', headerName: t('common.name'), filterPlaceholder: t('common.filter-name'), style: { minWidth: '12rem' }, filter: true, bodyTemplate: null},
            {name: 'menus.menuNameFr', headerName: "Menus", filterPlaceholder: 'Filtrer par menus', style: { minWidth: '12rem' }, filter: true, bodyTemplate: menusBodyTemplate},
            {name: 'createdAt', filterField: 'createdAt', dataType: 'date', headerName: 'Créé le', filterPlaceholder: t('facturation.create-date-filter'), style: { minWidth: '6rem' }, filter: true, bodyTemplate: datePaiementBodyTemplate, filterElement: dateFilterTemplate},
            {name: 'actions', headerName: 'Actions', filterPlaceholder: '', style: { minWidth: '6rem'}, filter: false, bodyTemplate: getActionsTemplate},
        ]
    };

    const getActionsTemplate = (rowData) => {
        return (
            <div className="d-flex justify-content-center gap-1">
                {hasMenu('MENPARAMUSER') && canDo('MENPARAMUSER', 'UPDATEROLE') && (
                    <button 
                        className="btn btn-sm btn-outline-primary"
                        onClick={e => updateAction(rowData)}
                        title={t('common.edit')}
                    >
                        <i className="fa fa-pencil"></i>
                    </button>
                )}
                {hasMenu('MENPARAMUSER') && canDo('MENPARAMUSER', 'DELETEROLE') && (
                    <button 
                        className="btn btn-sm btn-outline-danger"
                        onClick={() => handleDelete(rowData)}
                        title={t('common.delete')}
                    >
                        <i className="fa fa-trash"></i>
                    </button>
                )}
            </div>
        );
    };

    const handleDelete = (rowData) => {
        swal({
            title: "Supprimer le role " + rowData.roleNameFr + " ?",
            text: "Une fois le role supprimé, il ne pourra plus être accessible",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        }).then((willDelete) => {
            if (willDelete) {
                let data = { id: rowData.roleId };
                props.dispatch(startLoader());
                props.dispatch(deleteParamAction('role', data));
            }
        });
    };

    const dateFilterTemplate = (options) => {
        return <Calendar 
            value={options.value} 
            onChange={(e) => options.filterCallback(e.value, options.index)} 
            dateFormat="dd/mm/yy" 
            placeholder="dd/mm/yyyy" 
            mask="99/99/9999" 
        />;
    };

    const datePaiementBodyTemplate = (rowData) => {
        return formatDate(rowData.createdAt);
    };

    const menusBodyTemplate = (rowData) => {
        return rowData.menus?.map((menu, index) => {
            return <Tag key={index} value={menu.menuNameFr} severity={'secondary'} className="me-1" />;
        });
    };

    const focusOnMenu = (index, e) => {
        e.preventDefault();
        if(e.target.id === "sup-menu"){
            if(index < menus.length - 1) {
                setMenus(menus.map((menu, i) => {
                    menu.active = i === index + 1;
                    return menu;
                }))
            }
            setMenus(menus.filter((elt, i) => i !== index));
        }else{
            setMenus(menus.map((menu, i) => {
                menu.active = i === index;
                return menu;
            }))
        };
    }

    const formatDate = (value) => {
        return value.toLocaleDateString('fr-FR', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric'
        });
    };

    const canDo = (menuCode, actionCode) => {
        let theMenu = props.currentUser.menus?.find(menu => menu.code === menuCode);
        if(!theMenu){
            return false;
        }else{
            return theMenu.actionMenus?.filter(action => action.code === actionCode).length > 0;
        }
    }
    
    const hasMenu = (menuCode) => {
        return props.currentUser.menus?.filter(menu => menu.code === menuCode).length > 0;
    }

    useEffect(() => {
        initFilters();    
    }, []);

    const resetForm = () => {
        setId("");
        setNameFr("");
        setNameEn("");
        setCode("");
        setMenus([]);
        setErrors(errorsObj);
        setUpdateMode(false);
    };

    function onRoleSave(e) {
        e.preventDefault();
        let error = false;
        const errorObj = { ...errorsObj };
        if (code === '') {
            errorObj.code = t('common.code-required');
            error = true;
        }
        if (nameFr === '') {
            errorObj.name = t('common.name-required');
            error = true;
        }
        
        setErrors(errorObj);
        if (error) {
            swal('Oops', t('common.check-form-fields'), "error");
            return;
        }
        
        props.dispatch(startLoader());
        
        let obj = { 
            nameFr: nameFr,
            nameEn: nameFr, 
            code: code, 
            menus: menus.map(menu => {
                return {
                    menuId: menu.id,
                    actions: menu.actionMenus?.map(action => {
                        return action.choosen ? action.id : null;
                    }).filter(elt => elt)
                }
            }) 
        };

        if(updateMode) {
            props.dispatch(updateRoleAction(id, obj));
        }else{
            props.dispatch(createRolection(obj));
        }
        
        setAddCard(false);
        resetForm();
    }

    const updateAction = (data) => {
        setId(data.roleId);
        setNameFr(data.roleNameFr);
        setNameEn(data.roleNameEn);
        setCode(data.roleCode);
        
        setMenus(data.menus ? 
            props.menusData?.filter(elt => data.menus?.map(menRole => menRole.menuId).includes(elt.id)).map((menu) => {
                let menDActions = data.menus.find(elt => elt.menuId === menu.id).actions;
                menu.actionMenus = menu.actionMenus.map(action => {
                    action.choosen = menDActions.includes(action.id);
                    return action
                });
                return menu; 
            }) :
        []);
        setUpdateMode(true);
        setAddCard(true);
    }

    useEffect(() => {
        resetForm();
        setAddCard(false);
    }, [props.roles]);

    const newRoleCreate = () => {
        resetForm();
        setAddCard(true);
    }

    const handleDownloadTemplate = () => {
        console.log('Download role template');
    };

    return (
        <>
            {/* Header */}
            <div className="provider-type-header mb-0 form-head bg-white p-3 bt-5 border-top-solid">
                <div>
                    <h4 className="mb-1">
                        <FontAwesomeIcon icon={faUserTag} className="me-2" />
                        {t('user.roles')}
                    </h4>
                    <p className="text-muted mb-0 small">{t('common.manage-user-roles')}</p>
                </div>
                <div className="d-flex gap-2">
                    {/* <button
                        type="button"
                        className="btn btn-outline-primary btn-sm"
                        onClick={handleDownloadTemplate}
                    >
                        <FontAwesomeIcon icon={faDownload} className="me-1" />
                        {t("common.download-template")}
                    </button> */}
                    
                    {hasMenu('MENPARAMUSER') && canDo('MENPARAMUSER', 'CREATEROLE') && (
                        <button
                            type="button"
                            className="btn btn-primary btn-sm"
                            onClick={newRoleCreate}
                        >
                            <FontAwesomeIcon icon={faUserPlus} className="me-1" />
                            Nouveau Role
                        </button>
                    )}
                </div>
            </div>

            {/* Modal for creating/editing role */}
            <Modal 
                show={addCard} 
                onHide={() => setAddCard(false)}
                centered
                backdrop="static"
                size="lg"
            >
                <Modal.Header closeButton className="border-bottom">
                    <Modal.Title className="h5">
                        {!updateMode ? "Créer un nouveau role" : `Modifier le role ${nameFr}`}
                    </Modal.Title>
                </Modal.Header>
                
                <Modal.Body className="p-4">
                    <form onSubmit={onRoleSave}>
                        <div className="row mb-4">
                            <div className="col-md-4 mb-3">
                                <label className="form-label">{t('common.code')} du rôle</label>
                                <input
                                    type='text'
                                    className={`form-control ${errors.code ? 'is-invalid' : ''}`}
                                    placeholder='ROL'
                                    disabled={updateMode}
                                    value={code}
                                    onChange={(e) => setCode(e.target.value)}
                                />
                                {errors.code && <div className="invalid-feedback">{errors.code}</div>}
                            </div>
                            <div className="col-md-8 mb-3">
                                <label className="form-label">{t('common.label')}</label>
                                <input
                                    type='text'
                                    className={`form-control ${errors.name ? 'is-invalid' : ''}`}
                                    placeholder='Médecin'
                                    value={nameFr}
                                    onChange={(e) => setNameFr(e.target.value)}
                                />
                                {errors.name && <div className="invalid-feedback">{errors.name}</div>}
                            </div>
                            <div className="col-12 mb-3">
                                <label className="form-label">
                                    <FontAwesomeIcon icon={faBars} className="me-2" />
                                    Menus
                                </label>
                                <Select
                                    className="select-search"
                                    value={props.menusData?.filter(elt => menus.map(menu => menu.id).includes(elt.id)).map(res => ({...res, label: res.nameFr, value: res.id}))}
                                    placeholder="Choisir les menus"
                                    onChange={(vals) => {
                                        if(vals) {
                                            let currentMenusIds = menus.map(elt => {return elt.id});
                                            setMenus(vals.map((val, i) => {
                                                val.active = i === (vals.length - 1);
                                                val.actionMenus = currentMenusIds.includes(val.id) ? 
                                                    menus.find(elt => elt.id === val.id)?.actionMenus : 
                                                    val.actionMenus.map(action => {
                                                        action.choosen = false;
                                                        return action;
                                                    });
                                                return val;
                                            }))
                                        }else{
                                            setMenus([]);
                                        }
                                    }}
                                    disabled={props.showLoading}
                                    isMulti
                                    options={props.menusData?.map(res => ({...res, label: res.nameFr, value: res.id}))}
                                />
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-6">
                                <div className="card h-100">
                                    <div className="card-header bg-light">
                                        <h6 className="mb-0">
                                            <FontAwesomeIcon icon={faBars} className="me-2" />
                                            Menus sélectionnés
                                        </h6>
                                    </div>
                                    <div className="card-body p-0">
                                        <PerfectScrollbar
                                            className="widget-media dz-scroll ps ps--active-y"
                                            style={{ height: '300px' }}
                                        >
                                            {menus.length === 0 && (
                                                <div className="text-center p-4">
                                                    <span className='text-muted'>Ajouter des menus...</span>
                                                </div>
                                            )}
                                            {menus.length > 0 && (
                                                <div className="basic-list-group">
                                                    <ListGroup variant="flush">
                                                        {menus.map((menu, j) => (
                                                            <ListGroup.Item
                                                                action
                                                                active={menu.active}
                                                                key={j}
                                                                className="d-flex justify-content-between align-items-center"
                                                                onClick={(e) => focusOnMenu(j, e)}
                                                            >
                                                                <h6 className={menu.active ? "text-white m-0" : "text-dark m-0"}>
                                                                    <FontAwesomeIcon icon={faBars} className="me-2" />
                                                                    {menu.nameFr}
                                                                </h6>
                                                                <i className={'fa fa-close ' + (menu.active ? 'text-white' : 'text-primary')} id="sup-menu"></i>
                                                            </ListGroup.Item>
                                                        ))}
                                                    </ListGroup>
                                                </div>
                                            )}
                                        </PerfectScrollbar>
                                    </div>
                                </div>
                            </div>
                            <div className="col-6">
                                <div className="card h-100">
                                    <div className="card-header bg-light">
                                        <h6 className="mb-0">
                                            <FontAwesomeIcon icon={faCog} className="me-2" />
                                            Actions disponibles
                                        </h6>
                                    </div>
                                    <div className="card-body p-0">
                                        <PerfectScrollbar
                                            className="widget-media dz-scroll ps ps--active-y"
                                            style={{ height: '300px' }}
                                        >
                                            {menus.filter(elt => elt.active).length === 0 && (
                                                <div className="text-center p-4">
                                                    <span className='text-muted'>Sélectionner un menu</span>
                                                </div>
                                            )}
                                            {menus.filter(elt => elt.active).length > 0 && (
                                                <div className="basic-list-group">
                                                    <ListGroup variant="flush">
                                                        {menus.find(elt => elt.active)?.actionMenus?.map((actionM, j) => (
                                                            <ListGroup.Item
                                                                key={j}
                                                                className="d-flex align-items-center"
                                                            >
                                                                <div className='form-check'>
                                                                    <input
                                                                        type='checkbox'
                                                                        checked={actionM.choosen}
                                                                        onChange={(e) => {
                                                                            setMenus(menus.map(menu => {
                                                                                if(menu.id === actionM.menuId) {
                                                                                    menu.actionMenus[j].choosen = e.target.checked;
                                                                                }
                                                                                return menu;
                                                                            }))
                                                                        }}
                                                                        className='form-check-input'
                                                                        id={'customCheckBox' + actionM.code + j}
                                                                    />
                                                                    <label
                                                                        className='form-check-label text-primary fw-medium'
                                                                        htmlFor={'customCheckBox' + actionM.code + j}
                                                                    >
                                                                        <FontAwesomeIcon icon={faCog} className="me-2" />
                                                                        {actionM.nameFr}
                                                                    </label>
                                                                </div>
                                                            </ListGroup.Item>
                                                        ))}
                                                    </ListGroup>
                                                </div>
                                            )}
                                        </PerfectScrollbar>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </Modal.Body>
                
                <Modal.Footer className="border-top">
                    <button 
                        type="button" 
                        className="btn btn-outline-secondary"
                        onClick={() => setAddCard(false)}
                        disabled={props.showLoading}
                    >
                        {t('common.cancel')}
                    </button>
                    
                    {props.showLoading ? (
                        <BButton variant="primary" disabled>
                            <Spinner
                                as="span"
                                animation="border"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                            />
                            <span className="ms-2">{t('common.saving')}</span>
                        </BButton>
                    ) : (
                        <button 
                            type="submit" 
                            className="btn btn-primary"
                            onClick={onRoleSave}
                        >
                            {t('common.save')}
                        </button>
                    )}
                </Modal.Footer>
            </Modal>

            {/* DataTable */}
            <div className="card border-0 shadow-sm bg-white">
                <div className="card-body p-0">
                    <DataTableBase 
                        data={props.roles?.map(role => {
                            role.createdAt = new Date(role.createdAt);
                            return role;
                        })}
                        emptyMessage="Aucun role trouvé" 
                        filters={filters}
                        globalFiltersFields={['roleCode', 'roleNameFr', 'menuRole.menus.nameFr', 'createdAt']}
                        header={renderHeader()}
                        columns={setColumns()}
                        exportColumns={[
                            { title: 'Code', dataKey: 'roleCode' },
                            { title: t('common.name'), dataKey: 'roleNameFr' },
                            { title: 'Menus', dataKey: 'menus' },
                            { title: t('common.create-date'), dataKey: 'createdAt' },
                        ]}
                        rows={10} 
                        showExport={true}
                        exportFilename={"roles"}
                        loading={props.showLoading}
                    />
                </div>
            </div>

            {/* Custom CSS */}
            <style jsx>{`
                .provider-type-header {
                    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
                    color: white;
                    border-radius: 8px 8px 0 0;
                }
                
                .provider-type-header h4 {
                    color: white;
                    font-weight: 600;
                }
                
                .provider-type-header p {
                    color: rgba(255, 255, 255, 0.8);
                }
                
                .provider-type-header .btn-outline-primary {
                    border-color: rgba(255, 255, 255, 0.5);
                    color: white;
                }
                
                .provider-type-header .btn-outline-primary:hover {
                    background-color: rgba(255, 255, 255, 0.1);
                    border-color: white;
                }
                
                .provider-type-header .btn-primary {
                    background-color: rgba(255, 255, 255, 0.2);
                    border-color: rgba(255, 255, 255, 0.3);
                    color: white;
                }
                
                .provider-type-header .btn-primary:hover {
                    background-color: rgba(255, 255, 255, 0.3);
                    border-color: rgba(255, 255, 255, 0.5);
                }
                
                /* Card improvements */
                .card .card-header {
                    background-color: #f8f9fa;
                    border-bottom: 1px solid #dee2e6;
                }
                
                /* Button improvements */
                .btn-sm {
                    padding: 0.25rem 0.5rem;
                    font-size: 0.875rem;
                    border-radius: 0.25rem;
                    transition: all 0.2s ease;
                }
                
                .btn-outline-primary:hover {
                    transform: translateY(-1px);
                    box-shadow: 0 2px 4px rgba(0,123,255,0.2);
                }
                
                .btn-outline-danger:hover {
                    transform: translateY(-1px);
                    box-shadow: 0 2px 4px rgba(220,53,69,0.2);
                }
                
                /* Form validation styling */
                .is-invalid {
                    border-color: #dc3545;
                }
                
                .invalid-feedback {
                    display: block;
                    width: 100%;
                    margin-top: 0.25rem;
                    font-size: 0.875em;
                    color: #dc3545;
                }
                
                /* ListGroup improvements */
                .list-group-item.active {
                    background-color: #007bff;
                    border-color: #007bff;
                }
                
                .list-group-item:hover {
                    background-color: rgba(0,123,255,0.05);
                    cursor: pointer;
                }
                
                /* Tag improvements */
                .p-tag {
                    border-radius: 12px;
                    font-size: 0.75rem;
                    font-weight: 500;
                }
                
                /* Checkbox improvements */
                .form-check-input:checked {
                    background-color: #007bff;
                    border-color: #007bff;
                }
                
                .form-check-label {
                    cursor: pointer;
                }
                
                /* Responsive design */
                @media (max-width: 768px) {
                    .provider-type-header {
                        flex-direction: column;
                        gap: 1rem;
                    }
                    
                    .provider-type-header .d-flex {
                        flex-direction: column;
                        width: 100%;
                    }
                    
                    .modal-lg {
                        max-width: 95%;
                        margin: 1rem auto;
                    }
                }
            `}</style>
        </>
    );
};

const mapStateToProps = (state) => {
    return {
        roles: state.user.roleDatas,
        menusData: state.user.menusDatas,
        errorMessage: state.user.errorMessage,
        successMessage: state.user.successMessage,
        showLoading: state.user.showLoading,
        saveDone: state.user.saveDone,
        deleteDone: state.user.deleteDone,
        currentUser: currentUser(state)
    };
};

export default connect(mapStateToProps)(Role);